__turbopack_context__.v({
  "actionBar": "vO3pjW_actionBar",
  "checkBoxGroupWrapper": "vO3pjW_checkBoxGroupWrapper",
  "donorForm": "vO3pjW_donorForm",
  "infoMessageWrapper": "vO3pjW_infoMessageWrapper",
});
